import { TABLET_MIN_WIDTH } from '../utilities/constant_config';
import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet, formPost, jsonPost } from '../components/ajax';
import {
  disabledArrowsAccessibility,
  validateDateUtil
} from '../utilities/utility';

const $doc = $(document);
const clsHidden = 'hidden';
const clsReminderProgramContainer = '.reorder-reminder-program-container';
const clsSlider = '.continue-care-alternateProduct--bxslider';
const clsAternateProd = '.alternateProduct';
const clsAltPrdName = `${clsAternateProd} .alt-pdt-name`;
const clsChooseAlternatePdt = '.reorder-alt-product';
const itemCode = 'data-item-code';
const clsAlternateProductSection = '.reorder-alternate-product-section';
const clsAlternatePdt = '.alternateProduct-add-to-cart';
const clsproDetailsContinueCare = '.product-details-continueCare';
const altPdtItemCode = 'data-alt-item-no';
const totalProductAttr = 'data-total-product';
const totalInactivepdt = 'data-total-inactive-pdt';
const pdtItemCode = 'data-product-code';
const clsAddToCart = '.add-to-cart';
const dataIndex = 'data-index';
const addAlltoCartForm = '.addAlltoCartForm';
const clsAddAlltoCart = '.add-all-cart-btn';
const clsAddToCartForm = '.addToCartForm';
const reorderAltPdt = '.reorder-alt-pdt';
const altProductLength = 'data-alternate-length';
let productsPerPage = 8;
let idStore = [];
let productLength;
let firstPage;
let lastPage;
let noOfPages;
let paginationFlag = false;
let selectedAltPdtContainer;
let selectedAltButton;
let itemcode;
let selectedqty;
let reoderAlternateProductAjaxRequest = true;
let reorderAddtocartAjaxRequest = true;
let isRemoveItemClicked = false;
let nextStepForm = false;
const optionsCarouselDesktop = {
  minSlides: 2,
  maxSlides: 2,
  slideWidth: 400,
  randomStart: false,
  infiniteLoop: false,
  moveSlides: 2,
  pagerCustom: '#bx-pager',
  margin: 15,
  hideControlOnEnd: true,
  nextSelector: '.bxslider-carousel__continucare-next',
  prevSelector: '.bxslider-carousel__continucare-prev',
  onSlideAfter: () => {
    disabledArrowsAccessibility(clsSlider);
  }
};

const optionsMobileCarouselDesktop = {
  minSlides: 1,
  maxSlides: 1,
  slideWidth: 200,
  randomStart: false,
  infiniteLoop: false,
  moveSlides: 2,
  pagerCustom: '#bx-pager',
  margin: 15,
  hideControlOnEnd: true,
  nextSelector: '.bxslider-carousel__continucare-next',
  prevSelector: '.bxslider-carousel__continucare-prev',
  onSlideAfter: () => {
    disabledArrowsAccessibility(clsSlider);
  }
};
const requiredFiled = '.reorderSignIn .required-val';
const reorderSignIn = '#reorderSign';
let fieldVal;
const reorderYear = $('#reorderYear');
const reorderMonth = $('#reorderMonth');
const reorderDay = $('#reorderDay');
const reminderProgram = {
  resizeProductCarousel(selectedProductContainer) {
    if ($(window).width() > TABLET_MIN_WIDTH - 1) {
      $(clsSlider).bxSlider(optionsCarouselDesktop);
      if (selectedProductContainer) {
        const altPdtLength = selectedProductContainer
          .find(reorderAltPdt)
          .attr(altProductLength);
        if (altPdtLength < 5) {
          $('.bx-controls-direction a').addClass('disabled');
        }
      }
    } else {
      $(clsSlider).bxSlider(optionsMobileCarouselDesktop);
    }
    const carouselImgs = $('.continue-care-alternateProduct--bxslider').find(
      'img:not([src=""])'
    );
    carouselImgs.on('load', () => {
      disabledArrowsAccessibility(clsSlider);
    });
    ACC.utility.setEllipsis($(clsAltPrdName));
  },
  openAlternateProduct() {
    event.preventDefault();
    selectedAltButton = $(this);
    const itemNo = $(this).attr(itemCode);
    const selectedChooseAlt = $(this)
      .parents(clsproDetailsContinueCare)
      .find(clsAlternateProductSection);
    const getUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.reorderReminder.chooseAlternateProduct}?itemNumber=${itemNo}`;
    if (!reoderAlternateProductAjaxRequest) return false;
    reoderAlternateProductAjaxRequest = false;
    htmlGet(getUrl)
      .then(responseData => {
        reoderAlternateProductAjaxRequest = true;
        const response = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
        selectedAltButton.addClass(clsHidden);
        selectedChooseAlt.html(response);
        $(clsAddAlltoCart).attr('disabled', true);
        reminderProgram.resizeProductCarousel(selectedChooseAlt);
      })
      .catch(error => {
        reoderAlternateProductAjaxRequest = true;
      });
  },
  addAlterProductToCart() {
    event.preventDefault();
    itemcode = $(this).attr(altPdtItemCode);
    const productImgUrl = $(this)
      .parents('.alternateProduct--items')
      .find('.alternateProduct--productImg img')
      .attr('src');
    const pdtName = $(this)
      .parents('.alternateProduct--items')
      .find('.alternateProduct-info__title')
      .text();

    const pdtContainer = $(this).parents(clsproDetailsContinueCare);
    const formInputpdtCode = `input[name="${formInput}"]`;
    selectedAltPdtContainer = $(this).parents(clsAlternateProductSection);
    selectedqty = pdtContainer.find('.pdt-item-quantity').text();
    pdtContainer.find('.pdt-item-number').text(itemcode);
    pdtContainer.find('#selected-pdt-code').val(itemcode);
    pdtContainer.find('.product-name').text(pdtName);
    pdtContainer.find('.reorder-main-pdt').attr('src', productImgUrl);
    const index = pdtContainer.attr(dataIndex);
    const formInput = `params[${index}].productCode`;
    if ($(formInputpdtCode).length === 0) {
      const pdtData = `<input type="hidden" name="params[${index}].productCode" value="${itemcode}" /><input type="hidden" name="params[${index}].quantity" value="${selectedqty}" />`;
      $(addAlltoCartForm).append(pdtData);
    } else {
      $(formInputpdtCode).val(itemcode);
    }
    const data = `productCode=${itemcode}&qty=${selectedqty}`;
    reminderProgram.addToCartFormSubmission(data, itemcode, true);
  },
  changeMainPdtDetails() {
    selectedAltPdtContainer.addClass(clsHidden);
    $(clsAddAlltoCart).attr('disabled', false);
    selectedAltButton
      .removeClass(clsHidden)
      .removeClass('reorder-alt-product')
      .addClass('add-to-cart');
    selectedAltButton.parents(clsAddToCartForm).append();
    selectedAltButton.find('.alt-button-text').html('Add to Cart');
    selectedAltButton
      .parents(clsAddToCartForm)
      .find('.discontinue-section')
      .addClass(clsHidden);
    const altPdtData = `<input type="hidden" name="productCode" value="${itemcode}" /><input type="hidden" name="qty" value="${selectedqty}" />`;
    selectedAltButton.parents(clsAddToCartForm).append(altPdtData);
  },
  addToCartFormSubmission(payload, pdtNo, chooseAltPdtFlag) {
    const url = `${ACC.config.encodedContextPath}${API_REFERENCE.reorderReminder.addToCart}`;
    if (!reorderAddtocartAjaxRequest) return false;
    reorderAddtocartAjaxRequest = false;
    formPost(url, payload)
      .then(response => {
        reorderAddtocartAjaxRequest = true;
        $('#status-product-name').text(pdtNo);
        $('.StatusUpdate').removeClass(clsHidden);
        const quantity = response.replace(/\"/g, '');
        $('.nav-cart .js-mini-cart-count')
          .find('.badge')
          .text(quantity);
        if (chooseAltPdtFlag) {
          reminderProgram.changeMainPdtDetails();
        }
      })
      .catch(error => {
        reorderAddtocartAjaxRequest = true;
      });
  },
  payloadCreation() {
    event.preventDefault();
    const pdtCode = $(this).attr(pdtItemCode);
    const formId = $(this)
      .parents(clsAddToCartForm)
      .attr('id');
    const formData = $(`#${formId}`).serialize();
    reminderProgram.addToCartFormSubmission(formData, pdtCode, false);
  },
  reminderPageSetPagination() {
    let hideCount = productsPerPage;
    let noOfCurrentDiv = $('.product-details-continueCare');
    const classNameCount = noOfCurrentDiv.length;
    let i = 1;
    for (i; i <= noOfPages; i++) {
      let endBox = `<div class="page endBox"><span tabindex="0" role="button" class="pageNo page-${i}" id="page-${i}">${i}</span></div>`;
      let midBox = `<div class="page midBox hidden"><span tabindex="0" role="button" class="pageNo page-${i}" id="page-${i}">${i}</span></div>`;

      if (i == 1) {
        $('.pages').append(endBox);
        const dotBoxHidden = `<div class="page hidden"><span class="pageNo dotboxstart">..</span></div>`;
        $('.pages').append(dotBoxHidden);
      }
      if (i == 2 || i == noOfPages) {
        $('.pages').append(endBox);
      }
      if (i > 2 && i < noOfPages - 1) {
        $('.pages').append(midBox);
      }
      if (noOfPages > 3) {
        if (i == noOfPages - 1) {
          let midBox = `<div class="page hidden"><span tabindex="0" role="button" class="pageNo page-${i}" id="page-${i}">${i}</span></div>`;
          $('.pages').append(midBox);
          const dotBox = `<div class="page"><span class="pageNo dotbox">..</span></div>`;
          $('.pages').append(dotBox);
        }
      }
    }
    $('.page-1').addClass('first');
    $(lastPage).addClass('last');
    for (let j = 0; j < classNameCount; j++) {
      noOfCurrentDiv[j].id = 'item-' + j;
      idStore.push(noOfCurrentDiv[j].id);
    }

    for (hideCount; hideCount <= productLength; hideCount++) {
      let hideDiv = '#item-' + hideCount;
      $(hideDiv).hide();
    }
  },
  calculatePaginationValues() {
    productLength =
      parseInt($(clsReminderProgramContainer).attr(totalProductAttr)) +
      parseInt($(clsReminderProgramContainer).attr(totalInactivepdt));
    noOfPages = Math.ceil(productLength / productsPerPage);
    lastPage = `.page-${noOfPages}`;
    firstPage = `.page-1`;
    if (noOfPages) {
      paginationFlag = true;
    } else {
      paginationFlag = false;
    }
    if (productLength > productsPerPage) {
      $('.reorder-reminder-left_nav').removeClass('hidden');
      $('.reorder-reminder-right_nav').removeClass('hidden');
    }
    if (noOfPages > 1) {
      reminderProgram.reminderPageSetPagination(productLength);
    }
    $('.page-1').addClass('active');
    $('.reorder-reminder-right_nav .reorder-arrow-right').addClass(
      'svg-icon_arrow_right'
    );
    $('.reorder-reminder-left_nav .reorder-arrow-left').addClass(
      'svg-icon_arrow_left_gray'
    );
    if (noOfPages < 3) {
      $('.dotbox')
        .parent()
        .remove();
      $('.dotbox')
        .parent()
        .remove();

      $('.dotboxstart')
        .parent()
        .remove();
    }
  },
  paginationNavigation() {
    const targetObj = $(this).attr('id');
    let activeElement = parseInt(
      document.getElementsByClassName('active')[1].innerHTML
    );
    let target;
    if (
      targetObj.length !== 0 &&
      targetObj !== undefined &&
      targetObj !== null
    ) {
      target = targetObj.split('-')[1];
    }

    let activeClass = '#' + 'page-' + activeElement;
    let pageId;
    reminderProgram.assignActiveArrow();
    if (activeElement > 1 && activeElement < noOfPages) {
      reminderProgram.assignVisibility(activeElement, target);
    }

    if (target == 'left_nav') {
      if ($(activeClass).hasClass('first')) {
        return false;
      } else {
        pageId = activeElement - 1;
        reminderProgram.reorderPageUpdateContent(pageId);
      }
    } else if (target == 'right_nav') {
      if ($(activeClass).hasClass('last')) {
        return false;
      } else {
        pageId = activeElement + 1;
        reminderProgram.reorderPageUpdateContent(pageId);
      }
    }
  },
  setActive(serialId) {
    if (!$(serialId).hasClass('active')) {
      $('span.active').removeClass('active');
      $(serialId).addClass('active');
      if (
        $(serialId)
          .parent()
          .hasClass('hidden')
      ) {
        $(serialId)
          .parent()
          .removeClass('hidden');
      }
    }
  },
  assignActiveArrow() {
    let activeElement;
    let targetActive = document.getElementsByClassName('active')[1];
    if (targetActive != undefined && targetActive != null) {
      activeElement = parseInt(targetActive.innerHTML);
    }

    let firstDiv = parseInt(1);
    if (activeElement > firstDiv && activeElement < noOfPages) {
      $('.reorder-reminder-right_nav .reorder-arrow-right').addClass(
        'svg-icon_arrow_right'
      );
      $('.reorder-reminder-left_nav .reorder-arrow-left').addClass(
        'svg-icon_arrow_left'
      );
      $('.reorder-reminder-right_nav .reorder-arrow-right').removeClass(
        'svg-icon_arrow_right_gray'
      );
      $('.reorder-reminder-left_nav .reorder-arrow-left').removeClass(
        'svg-icon_arrow_left_gray'
      );
    }
    if (activeElement == firstDiv) {
      $('.reorder-reminder-right_nav .reorder-arrow-right').addClass(
        'svg-icon_arrow_right'
      );
      $('.reorder-reminder-left_nav .reorder-arrow-left').addClass(
        'svg-icon_arrow_left_gray'
      );
      $('.reorder-reminder-right_nav .reorder-arrow-right').removeClass(
        'svg-icon_arrow_right_gray'
      );
    }
    if (activeElement == noOfPages) {
      $('.reorder-reminder-left_nav .reorder-arrow-left').removeClass(
        'svg-icon_arrow_left_gray'
      );
      $('.reorder-reminder-right_nav .reorder-arrow-right').addClass(
        'svg-icon_arrow_right_gray'
      );
      $('.reorder-reminder-left_nav .reorder-arrow-left').addClass(
        'svg-icon_arrow_left'
      );
    }
  },
  assignVisibility(activeElement, target) {
    if (paginationFlag) {
      let firstDiv = parseInt(1);
      let next = parseInt(activeElement) + 1;
      let previous = parseInt(activeElement) - 1;
      let addVisibilitynext = '.' + 'page-' + parseInt(next);
      let addVisibilityprev = '.' + 'page-' + parseInt(previous);

      if (activeElement > 2) {
        if (target == 'right_nav') {
          if (activeElement > firstDiv && activeElement < noOfPages) {
            $('.dotboxstart')
              .parent()
              .removeClass('hidden');
            if (next == noOfPages - 1) {
              $('.dotbox')
                .parent()
                .addClass('hidden');
            }
            if (
              $(addVisibilitynext)
                .parent()
                .hasClass('hidden')
            ) {
              $(addVisibilitynext)
                .parent()
                .removeClass('hidden');
              $(addVisibilityprev)
                .parent()
                .addClass('hidden');
            }
          }
        }
      }
      if (target == 'left_nav') {
        if (activeElement > firstDiv && activeElement < noOfPages) {
          $('.dotbox')
            .parent()
            .removeClass('hidden');
          if (previous === firstDiv + 1) {
            $('.dotboxstart')
              .parent()
              .addClass('hidden');
          }
          if (
            $(addVisibilityprev)
              .parent()
              .hasClass('hidden')
          ) {
            $(addVisibilityprev)
              .parent()
              .removeClass('hidden');
            $(addVisibilitynext)
              .parent()
              .addClass('hidden');
          }
        }
      }
    }
  },
  reorderPageUpdateContent(pageId) {
    let firstDiv = (pageId - 1) * productsPerPage;
    let lastDiv = parseInt(firstDiv) + parseInt(productsPerPage);
    let updatedArray = [];
    updatedArray = idStore.slice(firstDiv, lastDiv);
    let hideInit = 0;
    let showInit = 0;
    let serialId = '.' + 'page-' + pageId;

    reminderProgram.setActive(serialId);
    reminderProgram.assignActiveArrow();
    for (hideInit; hideInit <= idStore.length; hideInit++) {
      let hideDiv = '#item-' + hideInit;

      $(hideDiv).hide();
    }
    for (showInit; showInit <= updatedArray.length; showInit++) {
      let showDiv = '#' + updatedArray[showInit];
      $(showDiv).show();
    }
  },
  onNumberClick() {
    let pageId = $(this)
      .find('.pageNo')
      .text();
    reminderProgram.reorderPageUpdateContent(pageId);
  },
  makeTabsActive() {
    const currentUrl = window.location.href;
    const reorderUrl = 'my-account-home/reorder-reminder/items';
    const recentUrl = 'my-account-home/reorder/item';
    const reorderTab = '.reorder-reminder-tab';
    const recentTab = '.recent-tab';
    const nonSelectedOMTab = 'nonSelectedOM_tab';
    const selectedOMTab = 'selectedOM_tab';

    if (currentUrl.indexOf(reorderUrl) !== -1) {
      $(reorderTab)
        .removeClass(nonSelectedOMTab)
        .addClass(selectedOMTab);
      $(recentTab)
        .removeClass(selectedOMTab)
        .addClass(nonSelectedOMTab);
    } else if (currentUrl.indexOf(recentUrl) !== -1) {
      $(recentTab)
        .removeClass(nonSelectedOMTab)
        .addClass(selectedOMTab);
      $(reorderTab)
        .removeClass(selectedOMTab)
        .addClass(nonSelectedOMTab);
    }
  },

  toggleSignIn() {
    let empty = false;
    $(requiredFiled).each((i, obj) => {
      fieldVal = $(obj).val();
      if (fieldVal < 1 || fieldVal === '' || fieldVal === null) {
        empty = true;
      }
    });

    if (empty) {
      $(reorderSignIn).prop('disabled', true);
    } else {
      $(reorderSignIn).prop('disabled', false);
    }
  },

  submitSignIn() {
    if (validateDateUtil(reorderMonth, reorderDay, reorderYear) === false) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      return false;
    }else{
      if(!nextStepForm){
        nextStepForm = true;
        $('#chhReorderReminderPageForm').submit();
      }
    }
  },
  removeItems(evt) {
    const productCode = $(this).attr('data-product-code');
    const url = `${ACC.config.encodedContextPath}${API_REFERENCE.reorderReminder.removeItem}?productCode=${productCode}`;
    //let reqPayload = { productCode: productCode };
    if (isRemoveItemClicked) return;
    isRemoveItemClicked = true;
    /*jsonPost(url)
      .then(response => {
        location.reload();
      })
      .catch(error => {
        isRemoveItemClicked = false;
      });*/
    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      contentType: 'application/json',
      data: {},
      success: function(responseData) {
        if (responseData) location.reload();
        else isRemoveItemClicked = false;
      },
      error: function(error) {
        isRemoveItemClicked = false;
      }
    });
  },

  init() {
    this.resizeProductCarousel();
    $doc.on('click', clsChooseAlternatePdt, this.openAlternateProduct);
    $doc.on('click', clsAlternatePdt, this.addAlterProductToCart);
    $doc.on('click', clsAddToCart, this.payloadCreation);
    $doc.on(
      'click',
      '.reorder-reminder-left_nav, .reorder-reminder-right_nav',
      this.paginationNavigation
    );
    $doc.on(
      'click',
      `${clsReminderProgramContainer} .page`,
      this.onNumberClick
    );
    $doc.on('click', reorderSignIn, this.submitSignIn);
    $doc.on('input', requiredFiled, this.toggleSignIn);
    $doc.on('selectmenuchange', requiredFiled, this.toggleSignIn);
    $('#reorderMonth,#reorderDay,#reorderYear').selectmenu();
    $doc.on('click', '.trash-btn-container .js-event', this.removeItems);
  }
};

export default reminderProgram;
reminderProgram.init();

$(document).ready(function() {
  reminderProgram.makeTabsActive();
  reminderProgram.calculatePaginationValues();
});
